import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { useLojaStepContext } from 'pages/cadastro/loja/contexts';
import { ColunaDinamicaProps } from 'pages/cadastro/loja/types';
import { getInitialValueColunasDinamicas, getTypeChave } from 'pages/cadastro/loja/utils';

export function useQueryColunasDinamicas() {
    const requestListagem = useRequestListagem();
    const { activeStep } = useLojaStepContext();
    const { id } = useParams();

    return useQuery<{ lojaColunas: ColunaDinamicaProps[] }>({
        queryKey: ['getlojaColunas', activeStep.idConfiguracaoPropriedadeGrupoExibicao, id],
        queryFn: () =>
            requestListagem({
                url: '/gestao/configuracaopropriedade/loja',
                filter: [
                    {
                        property: 'idConfiguracaoPropriedadeGrupoExibicao',
                        value: String(activeStep.idConfiguracaoPropriedadeGrupoExibicao),
                        operator: 'eq',
                    },
                    {
                        property: 'idLoja',
                        value: id,
                        operator: 'eq',
                    },
                ],
                sort: [{ property: 'nrSequencia', direction: 'ASC' }],
                limit: 100,
            }).then((res) => {
                const lojaColunas = res.data.data.map((item: ColunaDinamicaProps) => {
                    let dsValor = item.dsValor || getInitialValueColunasDinamicas(item.dsChave);

                    if (dsValor && ['vl', 'pe'].includes(getTypeChave(item.dsChave))) {
                        dsValor = parseFloat(dsValor as string).toFixed(2);
                    }

                    return {
                        ...item,
                        dsValor,
                    };
                });

                return { lojaColunas };
            }),
    });
}
